import { loadView } from '@/router'

export default [
  {
    path: 'carriers',
    name: 'manage-carriers',
    component: loadView('Application/Manage/Carriers'),
    props: true,
    redirect: {
      name: 'manage-carriers-list'
    },
    showInAlfred: true,
    alfredTitle: 'Manage - Carriers',
    children: [
      {
        path: 'list',
        name: 'manage-carriers-list',
        component: loadView('Application/Manage/Carriers/List'),
        props: true
      },
      {
        path: ':carrierId',
        name: 'manage-carriers-carrier',
        component: loadView('Application/Manage/Carriers/Carrier'),
        props: true,
        redirect: {
          name: 'manage-carriers-carrier-services'
        },
        children: [
          {
            path: 'services',
            name: 'manage-carriers-carrier-services',
            component: loadView('Application/Manage/Carriers/Carrier/Services'),
            props: true
          },
          {
            path: 'contacts',
            name: 'manage-carriers-carrier-contacts',
            component: loadView('Application/Manage/Carriers/Carrier/Contacts'),
            props: true
          },
          // {
          //   path: 'depots',
          //   name: 'manage-carriers-carrier-depots',
          //   component: loadView('Application/Manage/Carriers/Carrier/Depots'),
          //   props: true
          // },
          {
            path: 'locationcarrierzones',
            name: 'manage-carriers-carrier-locationcarrierzones',
            component: loadView('Application/Manage/Carriers/Carrier/LocationCarrierZones'),
            props: true
          },
          // {
          //   path: 'times',
          //   name: 'manage-carriers-carrier-times',
          //   component: loadView('Application/Manage/Carriers/Carrier/Times'),
          //   props: true
          // },
          // {
          //   path: 'activity',
          //   name: 'manage-carriers-carrier--activity',
          //   component: loadView('Application/Configuration/Activity/List')
          // },
          {
            path: 'notes',
            name: 'manage-carriers-carrier-notes',
            component: loadView('Application/Manage/Carriers/Carrier/Notes'),
            props: true
          },
          {
            path: 'times',
            name: 'manage-carriers-carrier-times',
            component: loadView('Application/Manage/Carriers/Carrier/Times'),
            props: true
          },
          {
            path: 'attachments',
            name: 'manage-carriers-carrier-attachments',
            component: loadView('Application/Manage/Carriers/Carrier/Attachments'),
            props: true
          },
          // {
          //   path: 'activity',
          //   name: 'manage-carriers-carrier--activity',
          //   component: loadView('Application/Configuration/Activity/List')
          // },
          {
            path: 'configurations',
            name: 'manage-carriers-carrier-configurations',
            component: loadView('Application/Manage/Carriers/Carrier/Configurations'),
            props: true,
            redirect: {
              name: 'manage-carriers-carrier-configurations-detail'
            },
            children: [
              {
                path: 'detail',
                name: 'manage-carriers-carrier-configurations-detail',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Detail'),
                props: true
              },
              {
                path: 'label',
                name: 'manage-carriers-carrier-configurations-label',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Label'),
                props: true
              },
              {
                path: 'consignment',
                name: 'manage-carriers-carrier-configurations-consignment',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Consignment'),
                props: true
              },
              {
                path: 'manifest',
                name: 'manage-carriers-carrier-configurations-manifest',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Manifest'),
                props: true
              },
              {
                path: 'EDI',
                name: 'manage-carriers-carrier-configurations-edi',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/EDI'),
                props: true
              },
              {
                path: 'tracking',
                name: 'manage-carriers-carrier-configurations-tracking',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Tracking'),
                props: true
              },
              {
                path: 'pickup',
                name: 'manage-carriers-carrier-configurations-pickup',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Pickup'),
                props: true
              },
              {
                path: 'invoice',
                name: 'manage-carriers-carrier-configurations-invoice',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Invoicing'),
                props: true
              },
              {
                path: 'terms',
                name: 'manage-carriers-carrier-configurations-terms',
                component: loadView('Application/Manage/Carriers/Carrier/Configurations/Terms'),
                props: true
              }
            ]
          },
          {
            path: 'tracking',
            name: 'manage-carriers-carrier-tracking',
            component: loadView('Application/Manage/Carriers/Carrier/Tracking'),
            props: true,
            redirect: {
              name: 'manage-carriers-carrier-tracking-seeds'
            },
            children: [
              {
                path: 'detail',
                name: 'manage-carriers-carrier-tracking-seeds',
                component: loadView('Application/Manage/Carriers/Carrier/Tracking/Seeds'),
                props: true
              },
              {
                path: 'label',
                name: 'manage-carriers-carrier-tracking-events',
                component: loadView('Application/Manage/Carriers/Carrier/Tracking/Events'),
                props: true
              }
            ]
          }
        ]
      }
    ]
  }
]
